import { safeLocalStorage } from "@/utils/safeStorages";
import siteConfig from "@/variables";
import { ProductGame } from "@/@types/common";

const getGameIdFromPath = (): string | undefined => {
  if (typeof window === "undefined") {
    return undefined;
  }

  const { pathname } = window.location;
  const [locale, gameIdFromPath] = pathname.split("/").filter(Boolean);

  if (!locale) {
    return undefined;
  }

  // If locale doesn't have a -, then we're on a short url, like /lol/champion-1
  // So we return the locale directly.
  if (!locale.includes("-")) {
    return locale;
  }
  return gameIdFromPath;
};

export const useGame = (fromPath: boolean = false): ProductGame => {
  const gameIdFromStorage: string | undefined = safeLocalStorage.getItem(siteConfig.KEY_GAME_ID) ?? undefined;
  const gameIdFromPath: string | undefined = getGameIdFromPath();

  const isProductId = (gameId: string): gameId is ProductGame =>
    (Object.values(ProductGame) as string[]).includes(gameId);

  if (fromPath && gameIdFromPath && isProductId(gameIdFromPath)) {
    return gameIdFromPath;
  }

  if (gameIdFromStorage && isProductId(gameIdFromStorage)) {
    return gameIdFromStorage;
  } else {
    return ProductGame.LeagueOfLegends;
  }
};
